import React, { Component } from "react";
import {
  Col,
  Row,
  Statistic,
  Layout,
  Typography,
  Card,
  Button,
  Badge,
  Tag,
} from "antd";
import PieChart from "./charts/PieChart";
import BarChartArticles from "./charts/BarChartArticles";
import BarChartFileTypes from "./charts/BarChartFileTypes";
import ScatterChartResolution from "./charts/ScatterChartResolution";
import {
  ReadOutlined,
  AppstoreOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";
import orderedTag from "./charts/orderTag";
import AssessmentTag from "../components/AssessmentTag";
import CountUp from "react-countup";

const formatter = (value) => <CountUp end={value} separator="," />;

const { Content } = Layout;
const { Text, Link } = Typography;

const renderNumberOfImages = (r) => {
  const numberOfImages = r.n_images;
  var color = "#40A9FF";

  switch (numberOfImages) {
    case 0:
      color = "#FF7875";
      break;

    case 1:
      color = "#91D5FF";
      break;

    default:
      break;
  }

  return <Badge count={numberOfImages} showZero color={color} />;
};

export default class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      barValue: "importance",
    };
  }

  displayTopArticles = (d) => {
    var data = d.sort(
      (a, b) =>
        a.n_images - b.n_images ||
        orderedTag(a.importance).localeCompare(orderedTag(b.importance)) ||
        orderedTag(a.quality).localeCompare(orderedTag(b.quality))
    );
    var selection = Math.floor(data.length * 0.1);
    if (data.length < selection) {
      selection = data.length;
    }

    data = data
      .slice(0, selection)
      .sort(() => Math.random() - 0.5)
      .slice(0, 3);

    var cards = [];
    data.forEach((article) => {
      const card = (
        <Col span={8}>
          <Card
            title={article.article}
            extra={
              <a href={article.article_link} target="_blank">
                Contribute
              </a>
            }
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>{renderNumberOfImages(article)} images</div>
              <div>
                <AssessmentTag type="importance" text={article.importance} />
                <AssessmentTag type="quality" text={article.quality} />
              </div>
            </div>
          </Card>
        </Col>
      );
      cards.push(card);
    });
    return <Row gutter={20}>{cards}</Row>;
  };

  displayTopImages = (d) => {
    var data = d.filter(function (image) {
        return image.file_type != "svg" && image.resolution == "Low-res";
      }),
      data = data.sort((a, b) => a.repetitions - b.repetitions);
    var selection = Math.floor(data.length * 0.2);
    if (data.length < selection) {
      selection = data.length;
    }

    data = data
      .slice(0, selection)
      .sort(() => Math.random() - 0.5)
      .slice(0, 3);

    var cards = [];
    data.forEach((image) => {
      const card = (
        <Col span={8}>
          <Card
            title={image.title.slice(5)}
            extra={
              <a href={image["page url"]} target="_blank">
                Contribute
              </a>
            }
            cover={
              <div style={{ height: "300px", border: "1px solid #f0f0f0" }}>
                <img
                  src={image["thumbnail url"]}
                  alt={image.title}
                  style={{
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  }}
                />
              </div>
            }
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                {image.width} x {image.height} px
              </div>
              <div>
                <AssessmentTag type="file type" text={image.file_type} />
                <AssessmentTag type="resolution" text={image.resolution} />
              </div>
            </div>
          </Card>
        </Col>
      );
      cards.push(card);
    });
    return <Row gutter={20}>{cards}</Row>;
  };

  navigateToArticles = () => {
    this.props.changeSection({ key: "articles" });
  };

  navigateToImages = () => {
    this.props.changeSection({ key: "images" });
  };

  render() {
    const { barValue } = this.state;
    return (
      <Layout>
        <Content
          className="viz-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignContent: "flex-start",
          }}
        >
          <Row gutter={[20, 20]} className="full-width">
            <Col span={12}>
              <Statistic
                className="overview-content overview-statistics"
                title={`Project ${window.$infoData.date}`}
                value={window.$infoData.name}
              />
            </Col>
            <Col span={4}>
              <Statistic
                className="overview-content overview-statistics"
                title="Total articles"
                value={this.props.data.length}
                prefix={<ReadOutlined />}
                formatter={formatter}
              />
            </Col>
            <Col span={4}>
              <Statistic
                className="overview-content overview-statistics"
                title="Total images"
                value={this.props.imagesData.length}
                prefix={<AppstoreOutlined />}
                formatter={formatter}
              />
            </Col>
            <Col span={4}>
              <Statistic
                className="overview-content overview-statistics"
                title="Articles without images"
                value={
                  this.props.data.filter(function (article) {
                    return article.n_images == 0;
                  }).length
                }
                prefix={<AppstoreAddOutlined />}
                formatter={formatter}
              />
            </Col>
            <Col span={8}>
              <div className="overview-content">
                <div className="chart-title">
                  <Text strong>Articles divided by number images</Text>
                </div>
                <PieChart data={this.props.data}></PieChart>
              </div>
            </Col>
            <Col span={16}>
              <div className="overview-content">
                <BarChartArticles data={this.props.data}></BarChartArticles>
              </div>
            </Col>
            <Col span={24}>
              <div className="overview-content">
                <div
                  className="chart-title"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Text strong>Articles without images you can improve</Text>
                  <Button onClick={this.navigateToArticles}>Show all</Button>
                </div>
                {this.displayTopArticles(this.props.data)}
              </div>
            </Col>
            <Col span={8}>
              <div className="overview-content">
                <div className="chart-title">
                  <Text strong>Images file types</Text>
                </div>
                <BarChartFileTypes
                  data={this.props.imagesData}
                ></BarChartFileTypes>
              </div>
            </Col>
            <Col span={16}>
              <div className="overview-content">
                <div className="chart-title">
                  <Text strong>Images resolution</Text>
                </div>
                <ScatterChartResolution
                  data={this.props.imagesData}
                ></ScatterChartResolution>
              </div>
            </Col>
            <Col span={24}>
              <div className="overview-content">
                <div
                  className="chart-title"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Text strong>Low resolution images you can improve</Text>
                  <Button onClick={this.navigateToImages}>Show all</Button>
                </div>
                {this.displayTopImages(this.props.imagesData)}
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    );
  }
}
